import { EventFeedbackApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useCreate() {
  return useAuthMutation(EventFeedbackApi.post);
}

export default useCreate;
